import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { UserPermissionsService } from './user-permissions.service';
import { ContractsComponent } from '../contracts/contracts/contracts.component';
import { ProjectNavigationComponent } from '../projects/project-navigation/project-navigation.component';
import { ProposalEditComponent } from '../projects/proposal-edit/proposal-edit.component';
import { SettingsNavigationComponent } from '../settings/settings-navigation/settings-navigation.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthenticationService, private userPermissionsService: UserPermissionsService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // return true;
    const user = this.authService.userValue;
    if (user) {
      let url: string = state.url;
      return this.checkUserLogin(route, url);
    } else {
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }


  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {

    if(route.component == ContractsComponent){
      return this.userPermissionsService.CanViewContractsTab;
    }
    
    if(route.component == ProjectNavigationComponent){
      return this.userPermissionsService.CanViewProposalsTab;
    }
    
    if(route.component == ProposalEditComponent){
      return this.userPermissionsService.CanViewProposalsTab;
    }
    
    if(route.component == SettingsNavigationComponent){
      return this.userPermissionsService.CanViewSettingsTab;
    }

    if (route.routeConfig?.path?.includes('scheduler')) {
      return this.userPermissionsService.CanViewSchedulerTab;      
    }
    


    // const userRole = this.authService.userType;
    // if (route.data.role && route.data.role.indexOf(userRole) === -1) {
    //   this.router.navigate(['']);
    //   return false;
    // }
    return true;
  }
}
